export const showHidePassword = {
  data () {
    return {
      MX_showHidePassword: true,
      MX_showHideRepeatPass: true,
      MX_showHideCurrentPass: true
    }
  },
  methods: {
    MX_togglePassVisibility (whatRefInput) {
      if (whatRefInput === 'repeatPassword') {
        this.MX_showHideRepeatPass = !this.MX_showHideRepeatPass
      } else if (whatRefInput === 'password' || whatRefInput === 'newPassword' || whatRefInput === 'bankPassword') {
        this.MX_showHidePassword = !this.MX_showHidePassword
      } else {
        this.MX_showHideCurrentPass = !this.MX_showHideCurrentPass
      }
      
      const refs = this.$refs[whatRefInput];
      let input = {};
      if (whatRefInput.includes('addBankAccount.')) {
        input = refs[0];
      } else {
        input = refs;
      }
      
      input.getAttribute('type') === 'password' ?
      input.setAttribute('type','text') :
      input.setAttribute('type', 'password')
    }
  }
};
